// Kept in its own tiny file so the entry bundle (src/index.js) can import
// the JWT sub claim and the login path without pulling in AppRouter or the
// large constants barrel.
// LOGIN_PATH mirrors AppRouter.LOGIN.path in src/common/AppRouter.js — keep
// them in sync if either changes.

export const JWT_SUBS = {
  SURVEY: 'survey',
  DEFAULT: 'default'
} as const;

export const LOGIN_PATH = '/login';
